export default __webpack_public_path__ + "static/coming-app-40be56382efe6f245ca3c46bb13cf1b0.png";